import React from 'react';
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../i18n/LanguageContext';

export default function About() {
  const { t } = useLanguage();
  const a = t.about;

  return (
    <section id="about" className="page-section">
      <div className="container">
        <div className="about-grid">
          <ScrollReveal className="about-visual">
            <div className="about-block">
              <div className="about-block-title">{a.valuesTitle}</div>
              <ul className="values-list">
                {a.values.map(v => (
                  <li key={v}><span className="val-dot" />{v}</li>
                ))}
              </ul>
            </div>
            <div className="about-float">
              <strong>{a.hubName}</strong>
              <span>{a.hubLabel}</span>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={80}>
            <span className="section-eyebrow">{a.eyebrow}</span>
            <div className="accent-line" />
            <h2 className="section-title">{a.title}</h2>
            <p style={{ color:'var(--gray)', fontSize:'15.5px', lineHeight:1.75, marginBottom:'20px', textAlign:'justify' }}>
              {a.p1}
            </p>
            <p style={{ color:'var(--gray)', fontSize:'15.5px', lineHeight:1.75, marginBottom:'32px', textAlign:'justify' }}>
              {a.p2}
            </p>
            <div className="vm-grid">
              <div className="vm-card">
                <div className="vm-card-title">{a.visionTitle}</div>
                <p>{a.visionText}</p>
              </div>
              <div className="vm-card">
                <div className="vm-card-title">{a.missionTitle}</div>
                <p>{a.missionText}</p>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
